// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { useMemo } from "@jvs-group/jvs-mairistem-tools";
import { FavoriteService } from "../services";
import { DataProvider } from "../../libs/components/DataProvider";
import { jsx as _jsx } from "react/jsx-runtime";
export const FavoriteDomainDataProvider = props => {
  const {
    children,
    domain
  } = props;
  const [favorites, loading, fetching] = FavoriteService.queryFavoritesByDomain(domain);
  return useMemo(() => /*#__PURE__*/_jsx(DataProvider, {
    data: favorites,
    loading: loading,
    fetching: fetching,
    children: children
  }), [children, loading, fetching, favorites]);
};